
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9zqwo", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryStreamingEntryPoint", () => $5a5369c594d86d6e$export$71e7180d7766ef0d);

var $gwFzn = parcelRequire("gwFzn");

var $2Rith = parcelRequire("2Rith");

var $dIouf = parcelRequire("dIouf");

var $aEsQl = parcelRequire("aEsQl");

var $dchHi = parcelRequire("dchHi");

var $7zIZo = parcelRequire("7zIZo");

var $kNy5p = parcelRequire("kNy5p");
const $5a5369c594d86d6e$export$71e7180d7766ef0d = (props)=>{
    const contentType = props.contentType;
    const aiAnalyticsConfig = {
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'quickSummary',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        additionalAttributes: {
            contentType: contentType
        }
    };
    const feedbackEntryPointID = contentType === 'whiteboard' ? (0, $aEsQl.WHITEBOARDS_SUMMARY_FEEDBACK_ENTRYPOINT_ID) : (0, $aEsQl.QUICK_SUMMARY_FEEDBACK_ENTRYPOINT_ID);
    const quickSummaryComponent = contentType === 'page' || contentType === 'blogpost' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kNy5p.QuickSummaryStreamingWrapper), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7zIZo.QuickSummaryStreamingComponent), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dchHi.FeedbackCollectorPropertiesProvider), {
        entrypointId: feedbackEntryPointID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: aiAnalyticsConfig
    }, quickSummaryComponent)));
};

});
parcelRegister("aEsQl", function(module, exports) {

$parcel$export(module.exports, "QUICK_SUMMARY_FEEDBACK_ENTRYPOINT_ID", () => $b0db4572f8505564$export$fc357534e58850b7);
$parcel$export(module.exports, "WHITEBOARDS_SUMMARY_FEEDBACK_ENTRYPOINT_ID", () => $b0db4572f8505564$export$10f702ba6af12582);
const $b0db4572f8505564$export$fc357534e58850b7 = 'd44ea02e-f7d1-491c-b061-53405badbbd3';
const $b0db4572f8505564$export$10f702ba6af12582 = '6907be36-5bd3-4f79-be18-6be58d6ff0da';

});

parcelRegister("7zIZo", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryStreamingComponent", () => $01ce9c12441cbb10$export$e6e415a985158eb3);
/* QuickSummaryStreamingComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $gUu2y = parcelRequire("gUu2y");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $4Gau4 = parcelRequire("4Gau4");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $6F6hl = parcelRequire("6F6hl");

var $iyIyT = parcelRequire("iyIyT");
var $lL1Cj = parcelRequire("lL1Cj");
var $3j1mV = parcelRequire("3j1mV");

var $dOOm2 = parcelRequire("dOOm2");
var $au4KV = parcelRequire("au4KV");
var $8LJEA = parcelRequire("8LJEA");
var $fooTI = parcelRequire("fooTI");

var $fXbFR = parcelRequire("fXbFR");

var $fYQcF = parcelRequire("fYQcF");

var $2n4Rt = parcelRequire("2n4Rt");

var $bQm3c = parcelRequire("bQm3c");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $9wGTI = parcelRequire("9wGTI");

var $8K7qD = parcelRequire("8K7qD");

var $fpKPq = parcelRequire("fpKPq");

var $4KbgO = parcelRequire("4KbgO");

var $i6Hw8 = parcelRequire("i6Hw8");

var $h04Gj = parcelRequire("h04Gj");

var $bbNJt = parcelRequire("bbNJt");

var $3RreU = parcelRequire("3RreU");

var $lYyez = parcelRequire("lYyez");
const $01ce9c12441cbb10$var$i18n = (0, $2nPZH.defineMessages)({
    quickSummaryAudioHeader: {
        id: "quick-summary.content.audio-header",
        defaultMessage: "Summary"
    }
});
const $01ce9c12441cbb10$var$containerStyles = null;
const $01ce9c12441cbb10$var$contentContainerStyles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $01ce9c12441cbb10$var$FooterObjectSidebarStyles = (0, $ecnYn.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $01ce9c12441cbb10$export$e6e415a985158eb3 = ({ contentId: contentId, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, contentPath: contentPath, contentType: contentType, setIsOpen: setIsOpen, isInObjectSidebar: isInObjectSidebar })=>{
    const summaryRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(summaryRef);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage, locale: locale } = (0, $dBxQj.default)();
    const contentLastUpdated = Math.floor(new Date(lastModifiedDate).getTime() / 1000);
    const isNonCachedResponse = (0, $gwFzn.useRef)(false);
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const experienceTrackerName = contentType === 'whiteboard' ? (0, $irVI7.QUICK_SUMMARY_WHITEBOARDS_EXPERIENCE) : (0, $irVI7.QUICK_SUMMARY_EXPERIENCE);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { analyticsProperties: analyticsProperties } = (0, $fpKPq.useQuickSummaryAnalyticsProperties)(contentLastUpdated, contentType);
    const isStreamingDone = (0, $gwFzn.useRef)(false);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const onStart = ()=>{
        experienceTracker.start({
            name: experienceTrackerName,
            attributes: {
                contentId: contentId
            }
        });
        (0, $8K7qD.QUICK_SUMMARY_DIALOG_INTERACTION_METRIC).start();
        trackAIInteractionInit();
    };
    const onError = (reason)=>{
        (0, $8K7qD.QUICK_SUMMARY_DIALOG_INTERACTION_METRIC).stop();
        trackAIResultError({
            aiErrorCode: reason.message.status_code,
            aiErrorMessage: reason.message.message_template
        });
        setIsStreamingDone();
    };
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'quickSummary',
                    source: source,
                    actionSubjectId: 'quickSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        dwellTime: getDwellTime(),
                        isAIMateSummary: true
                    }
                }
            }).fire();
            if (!isStreamingDone.current) trackAIInteractionDismiss();
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let aiSummaryStreamingConfig = {
        ari: pageAri ?? '',
        agentNamedId: 'page_summaries_agent',
        product: 'confluence',
        experienceId: 'page-summaries',
        locale: locale,
        summaryStyle: 'medium',
        summaryOutputMimetype: 'text/markdown-plus',
        delayChunkUpdate: {
            gap: 10,
            time: 20
        },
        onStart: onStart,
        onError: onError,
        onDone: setIsStreamingDone,
        featureFlags: {
            showFollowUps: isRovoEnabled
        }
    };
    if (contentType === 'whiteboard') aiSummaryStreamingConfig = {
        ari: pageAri ?? '',
        agentNamedId: 'whiteboard_summary_agent',
        product: 'confluence',
        experienceId: 'whiteboard-summary',
        locale: locale,
        delayChunkUpdate: {
            gap: 10,
            time: 20
        },
        onStart: onStart,
        onError: onError,
        onDone: setIsStreamingDone
    };
    const { content: content, state: state, followUpContent: followUpContent, error: error } = (0, $lL1Cj.useAISummaryStreaming)(aiSummaryStreamingConfig);
    (0, $gwFzn.useEffect)(()=>{
        if (state === (0, $iyIyT.AISummaryStreamingState).FinalResponse && content) {
            const summaryHeight = summaryRef.current?.scrollHeight ?? 0;
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'quickSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        summaryLocale: 'en-US',
                        contentLastUpdated: contentLastUpdated,
                        summaryHeight: summaryHeight,
                        maxSummaryHeight: (0, $bbNJt.MAX_SUMMARY_HEIGHT),
                        isAIMateSummary: true,
                        isValidSummary: (0, $3RreU.validateMarkdownByContentType)(contentType, content)
                    }
                }
            }).fire();
            trackAIResultView();
            (0, $8K7qD.QUICK_SUMMARY_DIALOG_INTERACTION_METRIC).stop();
        }
    }, [
        createAnalyticsEvent,
        contentId,
        contentLastUpdated,
        content,
        contentType,
        state,
        isRovoEnabled,
        trackAIResultView
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (state === (0, $iyIyT.AISummaryStreamingState).AnswerPart) isNonCachedResponse.current = true;
    }, [
        state
    ]);
    const { delayedContent: delayedContent, isComplete: isComplete } = (0, $2n4Rt.useAIMockStreaming)(content);
    const renderPopupContent = ()=>{
        switch(state){
            case (0, $iyIyT.AISummaryStreamingState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $iyIyT.AISummaryStreamingState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i6Hw8.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: error,
                    contentId: contentId,
                    experienceName: experienceTrackerName
                });
            case (0, $iyIyT.AISummaryStreamingState).AnswerPart:
            case (0, $iyIyT.AISummaryStreamingState).FinalResponse:
            case (0, $iyIyT.AISummaryStreamingState).FollowUp:
                const isStreamingInProgress = (0, $9wGTI.fg)('ai-smart-button-team-25') && (!isStreamingDone.current || !isComplete);
                const isResponseStateAnswerPart = state === (0, $iyIyT.AISummaryStreamingState).AnswerPart;
                const hideTelepointer = isStreamingInProgress ? false : !isResponseStateAnswerPart;
                let contentToRender = content;
                if (state === (0, $iyIyT.AISummaryStreamingState).FinalResponse && !isNonCachedResponse.current && (0, $9wGTI.fg)('ai-smart-button-team-25')) contentToRender = delayedContent;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
                    spread: "space-between",
                    xcss: $01ce9c12441cbb10$var$contentContainerStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6F6hl.default), {
                    role: "heading"
                }, formatMessage($01ce9c12441cbb10$var$i18n.quickSummaryAudioHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    padding: "space.250"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
                    space: "space.250"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bbNJt.SummaryPopupScrollableBody), {
                    useMaxHeight: !isInObjectSidebar,
                    ref: summaryRef,
                    "data-testid": "quick-summary-body-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fooTI.AITelepointerWrapper), {
                    hideTelepointer: hideTelepointer
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, contentToRender))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h04Gj.QuickSummaryFollowUpContainer), {
                    content: content,
                    contentPath: contentPath,
                    setIsOpen: setIsOpen,
                    isPageSummaryFollowUpEnabled: isRovoEnabled,
                    followUpContent: followUpContent
                }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                    xcss: isInObjectSidebar && $01ce9c12441cbb10$var$FooterObjectSidebarStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KbgO.AISummaryFooter), {
                    analyticsProperties: analyticsProperties,
                    contentId: contentId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    summaryText: content,
                    isHidden: state === (0, $iyIyT.AISummaryStreamingState).AnswerPart
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lYyez.ExperienceStreamingSuccess), {
                    state: state,
                    experienceName: experienceTrackerName
                }));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ...(0, $4Gau4.useResizingHeight)(),
        className: (0, $35pXk.default)([
            "_4t3i1osq"
        ])
    }, isInObjectSidebar ? renderPopupContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: state === (0, $iyIyT.AISummaryStreamingState).Initialization
    }, renderPopupContent()));
};

});
parcelRegister("4Gau4", function(module, exports) {

$parcel$export(module.exports, "useResizingHeight", () => $c747837ed372cb4a$export$da99457d6430d83);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $7hpmn = parcelRequire("7hpmn");

var $ig6yX = parcelRequire("ig6yX");

var $4c48T = parcelRequire("4c48T");

var $jtTDB = parcelRequire("jtTDB");

var $83H3T = parcelRequire("83H3T");

var $dclyF = parcelRequire("dclyF");

var $4QtAs = parcelRequire("4QtAs");
const $c747837ed372cb4a$export$da99457d6430d83 = ({ duration: calcDuration = ()=>(0, $4c48T.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $ig6yX.easeInOut) } = {})=>{
    const prevDimensions = (0, $gwFzn.useRef)();
    const [element, setElementRef] = (0, $83H3T.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $jtTDB.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $jtTDB.useRequestAnimationFrame)();
    (0, $4QtAs.useSnapshotBeforeUpdate)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $dclyF.useLayoutEffect)(()=>{
        if ((0, $7hpmn.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
const $c747837ed372cb4a$export$204d7b6d1491a2d3 = ({ children: children, ...props })=>{
    const resizing = $c747837ed372cb4a$export$da99457d6430d83(props);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gwFzn.Fragment), {
        children: children(resizing)
    });
};

});
parcelRegister("83H3T", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $68de0fcb6733268f$export$ff879f35a69d56b7);

var $gwFzn = parcelRequire("gwFzn");
const $68de0fcb6733268f$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $gwFzn.useRef)(null);
    const setRef = (0, $gwFzn.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});

parcelRegister("4QtAs", function(module, exports) {

$parcel$export(module.exports, "useSnapshotBeforeUpdate", () => $0136602141ebd577$export$9e95200239cd148b);

var $gwFzn = parcelRequire("gwFzn");

var $dclyF = parcelRequire("dclyF");
const $0136602141ebd577$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $gwFzn.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $dclyF.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};

});


parcelRegister("fXbFR", function(module, exports) {

$parcel$export(module.exports, "usePopupDwellTime", () => $d2d9cd8fe7c899bb$export$15dda63faa44a0df);

var $gwFzn = parcelRequire("gwFzn");

var $4PxT5 = parcelRequire("4PxT5");
const $d2d9cd8fe7c899bb$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $4PxT5.useOnScreen)(ref);
    const dwellTimeRef = (0, $gwFzn.useRef)(0);
    (0, $gwFzn.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};

});
parcelRegister("4PxT5", function(module, exports) {

$parcel$export(module.exports, "useOnScreen", () => $944e21aa736984a5$export$edb9b52ab3f1abbb);

var $gwFzn = parcelRequire("gwFzn");
const $944e21aa736984a5$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};

});


parcelRegister("2n4Rt", function(module, exports) {

$parcel$export(module.exports, "useAIMockStreaming", () => $25245d9ce314d691$export$400bbe8ab4bcbef3);

var $gwFzn = parcelRequire("gwFzn");
const $25245d9ce314d691$export$400bbe8ab4bcbef3 = (content, totalDuration = 1000, intervalDuration = 50)=>{
    const [delayedContent, setDelayedContent] = (0, $gwFzn.useState)('');
    const [isComplete, setIsComplete] = (0, $gwFzn.useState)(false);
    (0, $gwFzn.useEffect)(()=>{
        const contentLength = content?.length || 0;
        const numberOfUpdates = totalDuration / intervalDuration;
        const increment = Math.ceil(contentLength / numberOfUpdates);
        let currentIndex = 0;
        let interval;
        if (content?.length) interval = setInterval(()=>{
            currentIndex += increment;
            if (currentIndex >= contentLength) {
                currentIndex = contentLength;
                clearInterval(interval);
                setIsComplete(true);
            }
            setDelayedContent(content.slice(0, currentIndex));
        }, intervalDuration);
        return ()=>clearInterval(interval);
    }, [
        content,
        intervalDuration,
        totalDuration
    ]);
    return {
        delayedContent: delayedContent,
        isComplete: isComplete
    };
};

});

parcelRegister("8K7qD", function(module, exports) {

$parcel$export(module.exports, "QUICK_SUMMARY_DIALOG_INTERACTION_METRIC", () => $41b06f7c1927bcca$export$929821b56c8997a3);

var $lSOAM = parcelRequire("lSOAM");
var $jIOyV = parcelRequire("jIOyV");
const $41b06f7c1927bcca$export$929821b56c8997a3 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.QUICK_SUMMARY_DIALOG_INTERACTION)
});

});
parcelRegister("jIOyV", function(module, exports) {

$parcel$export(module.exports, "MORE_ACTIONS_DROPDOWN_INTERACTION", () => $4fa41f80373a2ebe$export$f49429c67898bd15);
$parcel$export(module.exports, "MOVE_PAGE_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$daaf73616fe91ce9);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$d4222bce9029f393);
$parcel$export(module.exports, "CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION", () => $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c);
$parcel$export(module.exports, "RESTRICTIONS_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$eb06363d6ef3b8dd);
$parcel$export(module.exports, "QUICK_SUMMARY_DIALOG_INTERACTION", () => $4fa41f80373a2ebe$export$ef2fb65c026ab7d3);
$parcel$export(module.exports, "OPEN_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$8122cf0ca2968a7b);
$parcel$export(module.exports, "INITIALIZE_LOOM_RECORDER_SDK_INTERACTION", () => $4fa41f80373a2ebe$export$ea9696a28a6fbc61);
$parcel$export(module.exports, "COMMENTS_SUMMARY_COMPONENT_INTERACTION", () => $4fa41f80373a2ebe$export$e561726b92a6162d);
$parcel$export(module.exports, "CREATE_SPACE_DRAWER_INTERACTION", () => $4fa41f80373a2ebe$export$e348981755bdab67);
$parcel$export(module.exports, "VIEW_AI_PRESENTATION_INTERACTION", () => $4fa41f80373a2ebe$export$af1eb8557193d022);
$parcel$export(module.exports, "AI_CONTENT_CATCHUP_INTERACTION", () => $4fa41f80373a2ebe$export$7f72b8ffbbbfef58);
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';

});


parcelRegister("fpKPq", function(module, exports) {

$parcel$export(module.exports, "useQuickSummaryAnalyticsProperties", () => $aa6941570d867a29$export$30e963d0f7aa411f);

var $gwFzn = parcelRequire("gwFzn");
const $aa6941570d867a29$export$30e963d0f7aa411f = (contentLastUpdated, contentType)=>{
    const [analyticsProperties, setAnalyticsProperties] = (0, $gwFzn.useState)({
        source: 'quickSummary'
    });
    (0, $gwFzn.useEffect)(()=>{
        setAnalyticsProperties((prev)=>{
            return {
                ...prev,
                additionalAnalyticsAttributes: {
                    contentLastUpdated: contentLastUpdated,
                    contentType: contentType
                }
            };
        });
    }, [
        contentLastUpdated,
        contentType
    ]);
    return {
        analyticsProperties: analyticsProperties
    };
};

});

parcelRegister("h04Gj", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryFollowUpContainer", () => $a83a3b428be2c3b8$export$33fc47be07b40981);

var $gwFzn = parcelRequire("gwFzn");

var $hhJ5M = parcelRequire("hhJ5M");
const $a83a3b428be2c3b8$export$33fc47be07b40981 = ({ isPageSummaryFollowUpEnabled: isPageSummaryFollowUpEnabled, followUpContent: followUpContent, content: content, contentPath: contentPath, setIsOpen: setIsOpen })=>{
    if (!isPageSummaryFollowUpEnabled) return null;
    if (!followUpContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hhJ5M.QuickSummaryFollowUpComponent), {
        followUpContent: followUpContent,
        summaryContent: content,
        contentPath: contentPath,
        setIsOpen: setIsOpen
    });
};

});
parcelRegister("hhJ5M", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryFollowUpComponent", () => $ce7766e3595e4f74$export$be7100384ad03472);
/* QuickSummaryFollowUpComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $eyWa4 = parcelRequire("eyWa4");

var $i25hX = parcelRequire("i25hX");

var $ab1fW = parcelRequire("ab1fW");

var $fYQcF = parcelRequire("fYQcF");
const $ce7766e3595e4f74$var$i18n = (0, $2nPZH.defineMessages)({
    quickSummaryUserQuery: {
        id: "quick-summary.follow-up.initial-human-prompt",
        defaultMessage: "Summarize this {link}"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ce7766e3595e4f74$var$FollowUpButtonWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_anlpuq6l _bepv12v5 _14hp1osq",
            __cmplp.className
        ])
    });
});
const $ce7766e3595e4f74$export$be7100384ad03472 = ({ followUpContent: followUpContent, summaryContent: summaryContent, contentPath: contentPath, setIsOpen: setIsOpen })=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    const contentLink = `${window.location.origin}${contentPath}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, followUpContent.map((followUp, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($ce7766e3595e4f74$var$FollowUpButtonWrapper, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ab1fW.FollowUpButton), {
            key: followUp.text,
            followUpIndex: index,
            followUpText: followUp.text,
            followUpType: followUp.type,
            experienceId: "page-summaries",
            onClick: ()=>{
                trackAIResultAction('followUpQuestionClick');
                publish({
                    type: 'chat-new',
                    source: 'page-summary',
                    data: {
                        name: followUp.text.substring(0, 30),
                        dialogues: [
                            {
                                human_message: {
                                    content: formatMessage($ce7766e3595e4f74$var$i18n.quickSummaryUserQuery, {
                                        link: contentLink
                                    })
                                },
                                agent_message: {
                                    content: summaryContent
                                }
                            }
                        ],
                        prompt: followUp.text
                    }
                });
                setIsOpen(false);
            }
        }))));
};

});


parcelRegister("3RreU", function(module, exports) {

$parcel$export(module.exports, "validateMarkdownByContentType", () => $425b01f4759cbbb1$export$57ab8841db807fb3);
const $425b01f4759cbbb1$var$WHITEBOARD_VALIDATION_REGEX = /^###\s.*\n(?:.*\n)*####\sKey\sTakeaways:(?:\n-\s.*)+$/;
function $425b01f4759cbbb1$var$validateWhiteboardMarkdown(markdown) {
    return $425b01f4759cbbb1$var$WHITEBOARD_VALIDATION_REGEX.test(markdown);
}
function $425b01f4759cbbb1$export$57ab8841db807fb3(contentType, markdown) {
    switch(contentType){
        case 'whiteboard':
            return $425b01f4759cbbb1$var$validateWhiteboardMarkdown(markdown);
        default:
            return undefined;
    }
}

});

parcelRegister("lYyez", function(module, exports) {

$parcel$export(module.exports, "ExperienceStreamingSuccess", () => $ead2a873ac7e199a$export$99f65bea3cd35484);

var $gwFzn = parcelRequire("gwFzn");

var $iyIyT = parcelRequire("iyIyT");

var $1eaCJ = parcelRequire("1eaCJ");
const $ead2a873ac7e199a$export$99f65bea3cd35484 = ({ state: state, experienceName: experienceName })=>{
    if (state === (0, $iyIyT.AISummaryStreamingState).FinalResponse || state === (0, $iyIyT.AISummaryStreamingState).FollowUp) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: experienceName
    });
    return null;
};

});


parcelRegister("kNy5p", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryStreamingWrapper", () => $b34fa4ed319780b5$export$d6400e0ab013b7f8);
/* QuickSummaryStreamingWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $4Gau4 = parcelRequire("4Gau4");

var $gdv5Z = parcelRequire("gdv5Z");

var $fYQcF = parcelRequire("fYQcF");

var $fXbFR = parcelRequire("fXbFR");

var $3j1mV = parcelRequire("3j1mV");

var $dOOm2 = parcelRequire("dOOm2");
var $au4KV = parcelRequire("au4KV");
var $8LJEA = parcelRequire("8LJEA");

var $kAaxz = parcelRequire("kAaxz");
var $d3UlG = parcelRequire("d3UlG");

var $2n4Rt = parcelRequire("2n4Rt");

var $bQm3c = parcelRequire("bQm3c");

var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $9wGTI = parcelRequire("9wGTI");

var $6mKj3 = parcelRequire("6mKj3");

var $f5Zrr = parcelRequire("f5Zrr");

var $9FrT8 = parcelRequire("9FrT8");

var $fpKPq = parcelRequire("fpKPq");

var $4mGnP = parcelRequire("4mGnP");

var $i6Hw8 = parcelRequire("i6Hw8");

var $eK9GW = parcelRequire("eK9GW");

var $8K7qD = parcelRequire("8K7qD");

var $bbNJt = parcelRequire("bbNJt");

var $3RreU = parcelRequire("3RreU");
const $b34fa4ed319780b5$var$styles = null;
const $b34fa4ed319780b5$export$d6400e0ab013b7f8 = ({ contentId: contentId, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, contentPath: contentPath, contentType: contentType, setIsOpen: setIsOpen, isInObjectSidebar: isInObjectSidebar })=>{
    const summaryRef = (0, $gwFzn.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(summaryRef);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { locale: locale } = (0, $dBxQj.default)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const isNonCachedResponse = (0, $gwFzn.useRef)(false);
    const isStreamingDone = (0, $gwFzn.useRef)(false);
    const currentAnswerChunk = (0, $gwFzn.useRef)(0);
    const contentLastUpdated = Math.floor(new Date(lastModifiedDate).getTime() / 1000);
    const experienceTrackerName = contentType === 'whiteboard' ? (0, $irVI7.QUICK_SUMMARY_WHITEBOARDS_EXPERIENCE) : (0, $irVI7.QUICK_SUMMARY_EXPERIENCE);
    const { analyticsProperties: analyticsProperties } = (0, $fpKPq.useQuickSummaryAnalyticsProperties)(contentLastUpdated, contentType);
    const { inlineLinkingContent: inlineLinkingContent, updateBuffer: updateBuffer, lastProcessedLength: lastProcessedLength, setLastProcessedLength: setLastProcessedLength, isBufferStreaming: isBufferStreaming } = (0, $f5Zrr.useInlineLinkingStreaming)(35, 5);
    const summaryLinkType = (0, $6mKj3.expVal)('confluence_ai_1p_inline_linking_quick_summary', 'cohort', 'default');
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'quickSummary',
                    source: source,
                    actionSubjectId: 'quickSummaryDialog',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        dwellTime: getDwellTime(),
                        isAIMateSummary: true
                    }
                }
            }).fire();
            if (!isStreamingDone.current) trackAIInteractionDismiss();
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [request, config] = (0, $gwFzn.useMemo)(()=>(0, $4mGnP.buildSummaryRequest)({
            contentAri: pageAri || '',
            locale: locale,
            enableFollowUp: isRovoEnabled,
            summaryLinkType: summaryLinkType
        }), [
        isRovoEnabled,
        locale,
        pageAri,
        summaryLinkType
    ]);
    const updateInlineLinkingContent = (0, $gwFzn.useCallback)((answerPartContent)=>{
        const fullContent = (0, $9FrT8.mapQuickSummaryInlineLinkingAgentResponseToMarkdown)(answerPartContent);
        const newContent = fullContent.slice(lastProcessedLength);
        updateBuffer(newContent);
        setLastProcessedLength(fullContent.length);
    }, [
        updateBuffer,
        setLastProcessedLength,
        lastProcessedLength
    ]);
    const onStateChange = (0, $gwFzn.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: experienceTrackerName,
                        attributes: {
                            contentId: contentId
                        }
                    });
                    (0, $8K7qD.QUICK_SUMMARY_DIALOG_INTERACTION_METRIC).start();
                    trackAIInteractionInit();
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                if (state.error) {
                    const { status_code: aiErrorCode, message_template: aiErrorMessage } = state.error.message;
                    (0, $8K7qD.QUICK_SUMMARY_DIALOG_INTERACTION_METRIC).stop();
                    trackAIResultError({
                        aiErrorCode: aiErrorCode,
                        aiErrorMessage: aiErrorMessage
                    });
                    setIsStreamingDone();
                    break;
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                isNonCachedResponse.current = true;
                if (summaryLinkType === 'inline' && currentAnswerChunk.current !== state.answerChunkIndex) updateInlineLinkingContent(state.content);
                currentAnswerChunk.current = state.answerChunkIndex;
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                if (state.content) {
                    const summaryHeight = summaryRef.current?.scrollHeight ?? 0;
                    createAnalyticsEvent({
                        type: 'sendScreenEvent',
                        data: {
                            name: 'quickSummaryDialog',
                            attributes: {
                                contentId: contentId,
                                contentType: contentType,
                                summaryLocale: 'en-US',
                                contentLastUpdated: contentLastUpdated,
                                summaryHeight: summaryHeight,
                                maxSummaryHeight: (0, $bbNJt.MAX_SUMMARY_HEIGHT),
                                isAIMateSummary: true,
                                isValidSummary: (0, $3RreU.validateMarkdownByContentType)(contentType, state.content)
                            }
                        }
                    }).fire();
                    trackAIResultView();
                    (0, $8K7qD.QUICK_SUMMARY_DIALOG_INTERACTION_METRIC).stop();
                    setIsStreamingDone();
                }
                break;
            default:
                break;
        }
    }, [
        contentId,
        contentLastUpdated,
        contentType,
        createAnalyticsEvent,
        experienceTracker,
        experienceTrackerName,
        trackAIResultError,
        trackAIInteractionInit,
        trackAIResultView,
        summaryLinkType,
        updateInlineLinkingContent
    ]);
    const [{ content: content, responseState: responseState, error: error, followUpContent: followUpContent }] = (0, $d3UlG.useConvoAIStreaming)(request, config, onStateChange);
    const { delayedContent: delayedContent, isComplete: isComplete } = (0, $2n4Rt.useAIMockStreaming)(content || '');
    const renderContent = ()=>{
        switch(responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $kAaxz.ConvoAIResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i6Hw8.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: error,
                    contentId: contentId,
                    experienceName: experienceTrackerName
                });
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                if (summaryLinkType === 'inline') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eK9GW.QuickSummaryComponent), {
                    ref: summaryRef,
                    analyticsProperties: analyticsProperties,
                    content: inlineLinkingContent,
                    contentId: contentId,
                    contentPath: contentPath,
                    contentType: contentType,
                    hideFooter: true,
                    hideTelepointer: false,
                    isRovoEnabled: isRovoEnabled,
                    setIsOpen: setIsOpen,
                    spaceKey: spaceKey,
                    isInObjectSidebar: isInObjectSidebar
                });
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
            case (0, $kAaxz.ConvoAIResponseState).FollowUp:
                const isExperienceSuccess = responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse || responseState === (0, $kAaxz.ConvoAIResponseState).FollowUp;
                const isStreamingInProgress = (0, $9wGTI.fg)('ai-smart-button-team-25') && (!isStreamingDone.current || !isComplete);
                const isResponseStateAnswerPart = responseState === (0, $kAaxz.ConvoAIResponseState).AnswerPart;
                let hideFooter = (0, $9wGTI.fg)('ai-smart-button-team-25') ? isStreamingInProgress : isResponseStateAnswerPart;
                if (!isBufferStreaming) hideFooter = false;
                let contentToRender = content || '';
                if (summaryLinkType === 'inline') contentToRender = inlineLinkingContent;
                if (responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && !isNonCachedResponse.current && (0, $9wGTI.fg)('ai-smart-button-team-25')) contentToRender = delayedContent;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eK9GW.QuickSummaryComponent), {
                    ref: summaryRef,
                    analyticsProperties: analyticsProperties,
                    content: contentToRender,
                    contentId: contentId,
                    contentPath: contentPath,
                    contentType: contentType,
                    followUpContent: isStreamingInProgress ? undefined : followUpContent,
                    hideFooter: hideFooter,
                    hideTelepointer: !hideFooter,
                    isRovoEnabled: isRovoEnabled,
                    setIsOpen: setIsOpen,
                    spaceKey: spaceKey,
                    isInObjectSidebar: isInObjectSidebar
                }), isExperienceSuccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.QUICK_SUMMARY_EXPERIENCE)
                }));
        }
    };
    const { ref: ref } = (0, $4Gau4.useResizingHeight)();
    if (isInObjectSidebar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: ref,
        className: (0, $35pXk.default)([
            "_4t3i1osq _ggmhs13h"
        ])
    }, renderContent());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $kAaxz.ConvoAIResponseState).Initialization
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        ref: ref
    }, renderContent()));
};

});
parcelRegister("9FrT8", function(module, exports) {

$parcel$export(module.exports, "mapQuickSummaryInlineLinkingAgentResponseToMarkdown", () => $a993110afc59ca55$export$acbced74b923417d);
const $a993110afc59ca55$export$acbced74b923417d = (responseContent)=>{
    if (!responseContent.keyTakeaways || responseContent.keyTakeaways.length === 0 || responseContent.keyTakeaways.length === 1 && Object.keys(responseContent.keyTakeaways[0]).length === 0) return '';
    let markdown = `${responseContent.introduction}\n\n`;
    markdown += responseContent.keyTakeaways.map((keyTakeaways)=>{
        if ('takeaway' in keyTakeaways && 'snippet' in keyTakeaways) {
            let formattedtakeaway = '';
            if (keyTakeaways.takeaway) {
                formattedtakeaway = `* ${keyTakeaways.takeaway}`;
                if (keyTakeaways.snippet) formattedtakeaway += ` ${keyTakeaways.snippet}`;
            }
            return formattedtakeaway;
        }
        return '';
    }).join('\n');
    return markdown;
};

});

parcelRegister("4mGnP", function(module, exports) {

$parcel$export(module.exports, "buildSummaryRequest", () => $dc69d79442a1f55f$export$9ebe94218768768c);
const $dc69d79442a1f55f$export$9ebe94218768768c = ({ contentAri: contentAri, enableFollowUp: enableFollowUp = false, locale: locale, summaryLinkType: summaryLinkType })=>{
    return [
        {
            ai_feature_input: {
                content_ari: contentAri,
                locale: locale,
                summary_output_mimetype: 'text/markdown-plus',
                summary_link_type: summaryLinkType
            }
        },
        {
            apiPath: 'v2/ai-feature/confluence-quick-summary',
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            enableFollowUp: enableFollowUp,
            enablePartialJson: summaryLinkType === 'inline',
            headers: {
                'x-experience-id': 'page-summaries',
                'x-product': 'confluence'
            }
        }
    ];
};

});

parcelRegister("eK9GW", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryComponent", () => $303989809f5e655d$export$ac9dc5f830bdb069);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gUu2y = parcelRequire("gUu2y");

var $6F6hl = parcelRequire("6F6hl");

var $6f0Oj = parcelRequire("6f0Oj");
var $1GzhS = parcelRequire("1GzhS");
var $ecnYn = parcelRequire("ecnYn");

var $fooTI = parcelRequire("fooTI");

var $bbNJt = parcelRequire("bbNJt");

var $h04Gj = parcelRequire("h04Gj");

var $4KbgO = parcelRequire("4KbgO");
const $303989809f5e655d$var$styles = (0, $ecnYn.xcss)({
    height: '100%'
});
const $303989809f5e655d$var$FooterObjectSidebarStyles = (0, $ecnYn.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $303989809f5e655d$var$i18n = (0, $2nPZH.defineMessages)({
    quickSummaryAudioHeader: {
        id: "quick-summary.content.audio-header",
        defaultMessage: "Summary"
    }
});
const $303989809f5e655d$export$ac9dc5f830bdb069 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ analyticsProperties: analyticsProperties, content: content, contentId: contentId, contentPath: contentPath, contentType: contentType, followUpContent: followUpContent, hideFooter: hideFooter, hideTelepointer: hideTelepointer, isRovoEnabled: isRovoEnabled, setIsOpen: setIsOpen, spaceKey: spaceKey, isInObjectSidebar: isInObjectSidebar }, summaryRef)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        spread: "space-between",
        xcss: $303989809f5e655d$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6F6hl.default), {
        role: "heading"
    }, formatMessage($303989809f5e655d$var$i18n.quickSummaryAudioHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        padding: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1GzhS.default), {
        space: "space.250",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bbNJt.SummaryPopupScrollableBody), {
        useMaxHeight: !isInObjectSidebar,
        ref: summaryRef,
        "data-testid": "quick-summary-body-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fooTI.AITelepointerWrapper), {
        hideTelepointer: hideTelepointer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gUu2y.default), null, content))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h04Gj.QuickSummaryFollowUpContainer), {
        content: content,
        contentPath: contentPath,
        setIsOpen: setIsOpen,
        isPageSummaryFollowUpEnabled: isRovoEnabled,
        followUpContent: followUpContent
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: isInObjectSidebar && $303989809f5e655d$var$FooterObjectSidebarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KbgO.AISummaryFooter), {
        analyticsProperties: analyticsProperties,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        summaryText: content,
        isHidden: hideFooter
    })));
});

});



parcelRegister("7Y4kW", function(module, exports) {

$parcel$export(module.exports, "ChatPillIcon", () => $eb50cc4a563796fc$export$38f9b635c1c454e7);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $lDwiy = parcelRequire("lDwiy");

var $enstx = parcelRequire("enstx");
const $eb50cc4a563796fc$export$38f9b635c1c454e7 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lDwiy))), {
        ...props,
        label: "",
        LEGACY_size: "small",
        LEGACY_fallbackIcon: (0, $enstx.default)
    });

});
parcelRegister("lDwiy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7997b223b163fea361e6870d11885d8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fc064b3d27071ad4$var$_react = $fc064b3d27071ad4$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $fc064b3d27071ad4$var$_baseNew = $fc064b3d27071ad4$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $fc064b3d27071ad4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiChat".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Rovo Chat.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fc064b3d27071ad4$var$AiChatIcon = (props)=>/*#__PURE__*/ $fc064b3d27071ad4$var$_react.default.createElement($fc064b3d27071ad4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2z" clip-rule="evenodd"/><path fill="currentcolor" d="M6 7.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$fc064b3d27071ad4$var$AiChatIcon.displayName = 'AiChatIcon';
var $fc064b3d27071ad4$var$_default = module.exports.default = $fc064b3d27071ad4$var$AiChatIcon;

});

parcelRegister("enstx", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e8e7f6bf451d29$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $id7ja = parcelRequire("id7ja");
const $92e8e7f6bf451d29$var$ChatIconGlyph = (props)=>/*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className,
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M8.00023 14.25C7.86431 14.25 7.73094 14.287 7.61439 14.3569L3.75024 16.6752V14V4.99998C3.75024 4.30963 4.30988 3.74999 5.00023 3.74998L15.0002 3.74984C15.6906 3.74984 16.2502 4.30948 16.2502 4.99984V12.9999C16.2502 13.6902 15.6906 14.2498 15.0003 14.2499L8.00023 14.25Z",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinejoin: "round",
                fill: "transparent"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "6",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "9",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                x: "12",
                y: "8",
                width: "2",
                height: "2",
                rx: "1",
                fill: "currentColor"
            })
        ]
    });
/**
 * __ChatIcon__
 */ const $92e8e7f6bf451d29$var$ChatIcon = ({ label: label, primaryColor: primaryColor, secondaryColor: secondaryColor, size: size, testId: testId })=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $id7ja.default), {
        label: label,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        size: size,
        testId: testId,
        glyph: $92e8e7f6bf451d29$var$ChatIconGlyph
    });
var $92e8e7f6bf451d29$export$2e2bcd8739ae039 = $92e8e7f6bf451d29$var$ChatIcon;

});


parcelRegister("lBFuf", function(module, exports) {

$parcel$export(module.exports, "ChatPill", () => $204b57ff8caef44c$export$e33faa86e0996d96);
$parcel$export(module.exports, "BrowseAgentsPill", () => $204b57ff8caef44c$export$76b47032dcd9063b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $1Whri = parcelRequire("1Whri");

var $hge3g = parcelRequire("hge3g");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $fVUfS = parcelRequire("fVUfS");

var $7Y4kW = parcelRequire("7Y4kW");

var $jz7J7 = parcelRequire("jz7J7");
const $204b57ff8caef44c$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $204b57ff8caef44c$var$styles = {
    button: "_2rkoiti9 _11c82smr _189ee4h9 _1dqonqa1 _1h6dmuej _syaz1gjq _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhk1w7a _irr3166n _1di61dty",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $204b57ff8caef44c$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                space: "space.075",
                alignBlock: "baseline",
                children: [
                    renderIcon ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7Y4kW.ChatPillIcon), {}) : null,
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: (0, $1Whri.cx)($204b57ff8caef44c$var$styles.queryText, whiteSpacePreWrap && $204b57ff8caef44c$var$styles.whiteSpacePreWrap),
                        children: children
                    })
                ]
            })
        })
    }));
const $204b57ff8caef44c$export$76b47032dcd9063b = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
        ref: ref,
        ...props,
        xcss: $204b57ff8caef44c$var$styles.button,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
            className: (0, $35pXk.default)([
                $204b57ff8caef44c$var$stylesCompiled.pillLineHeight
            ]),
            children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                space: "space.050",
                xcss: $204b57ff8caef44c$var$styles.buttonInline,
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hge3g))), {
                        color: "currentColor",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                        xcss: $204b57ff8caef44c$var$styles.queryText,
                        children: formatMessage((0, $jz7J7.default).browseAgentsPillLabel)
                    })
                ]
            })
        })
    });
});

});
parcelRegister("jz7J7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc6573ead9ef7c8$export$2e2bcd8739ae039);

var $2nPZH = parcelRequire("2nPZH");
var $5fc6573ead9ef7c8$export$2e2bcd8739ae039 = (0, $2nPZH.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse Agents"
    }
});

});



//# sourceMappingURL=QuickSummaryStreamingEntryPoint.cee5f993.js.map
